import { IProfileInSearch } from '@/shared/searchProvider';
import { normalizeSitemapProperty, normalizeUri } from '../utils';
import { IRingSearchItem } from './types';

class RingSearchProfileService {
  transform(item: IRingSearchItem): IProfileInSearch {
    const payload = item.payload ?? ({} as IRingSearchItem['payload']);
    const iconUrl = payload.iconUrl || '';
    const title = payload.title || '';

    return {
      logos: iconUrl ? [iconUrl] : [],
      shortDes: normalizeSitemapProperty(payload.description || ''),
      appName: '',
      iconUrl,
      applicationDisplayName: title,
      publisher: normalizeSitemapProperty(payload.publisher || ''),
      path: normalizeUri(payload.url || ''),
      appType: payload.profileType || '',
      partnerBadge: payload.partnerBadge || '',
      certifiedBadge: payload.certifiedBadge === true,
      appRatingEnabled: false,
      appRating: undefined,
      _id: payload.url || item.id,
    };
  }
}

export const ringSearchProfileService = new RingSearchProfileService();
